import { DataSource, Repository } from 'typeorm';
import { JobworkCreationEntity } from './entity/job-work-creation-entity';

export class JobworkCreationRepository extends Repository<JobworkCreationEntity> {
    constructor(dataSource: DataSource) {
        super(JobworkCreationEntity, dataSource.createEntityManager());
    }
}
